import React, { ReactNode } from 'react';
import { FlexyFormLabel } from '@europrocurement/flexy-components';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { FormHelperText, Input, SxProps } from '@mui/material';

export type ControlledTextareaProps = {
    name: string;
    inputlabel?: ReactNode;
    rules?: RegisterOptions;
    required?: boolean;
    sx?: SxProps;
};

const ControlledTextarea: React.FunctionComponent<ControlledTextareaProps> = function ({
    name,
    rules,
    inputlabel,
    required,
    sx,
}) {
    const { control } = useFormContext();

    const widgetProps = {
        sx: {
            width: '100%',
            minHeight: '250px',
            verticalAlign: 'top',
            display: 'flex',
            alignItems: 'flex-start',
            ...sx,
        },
    };

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <>
                    {inputlabel && inputlabel !== '' ? (
                        <FlexyFormLabel
                            required={required}
                            data-testid="test-id-FlexyInput-label"
                        >
                            {inputlabel}
                        </FlexyFormLabel>
                    ) : null}

                    <Input
                        {...widgetProps}
                        multiline
                        value={value}
                        onChange={onChange}
                    />
                    {error ? (
                        <FormHelperText
                            sx={{
                                margin: '4px 14px 0px 14px',
                            }}
                            error
                        >
                            {error?.message}
                        </FormHelperText>
                    ) : null}
                </>
            )}
        />
    );
};

export default ControlledTextarea;
